/* eslint-disable implicit-arrow-linebreak */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import AddToCalendar from '../views/AddToCalendar.vue';
import Thanks from '../views/Thanks.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'LayoutUnSlug',
    component: () => import(/* webpackChunkName: "unslug" */ '../layouts/UnSlug.vue'),
  },
  {
    path: '/:slug',
    name: 'Home',
    component: Home,
  },
  {
    path: '/:slug/addToCalendar',
    name: 'AddTocalendar',
    component: AddToCalendar,
  },
  {
    path: '/:slug/registraion-confirmation',
    name: 'thanks',
    component: Thanks,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
